import { c as classNames } from '../../../shared/bind-d9144132.js';
import { jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "item": "web_ui__Item__item",
  "with-divider": "web_ui__Item__with-divider"
};

var cssClasses = classNames.bind(styles);
var Item = function Item(_ref) {
  var children = _ref.children,
    _ref$divider = _ref.divider,
    divider = _ref$divider === void 0 ? false : _ref$divider,
    testId = _ref.testId;
  return /*#__PURE__*/jsx("li", {
    className: cssClasses(styles.item, {
      'with-divider': divider
    }),
    "data-testid": testId,
    children: children
  });
};

export { Item as default };
//# sourceMappingURL=Item.js.map
